import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ToolTipIcon from "/public/images/icons/tooltip.svg?react";

export default function ToolTip({ text }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipHeight, setTooltipHeight] = useState(0);
  const [tooltipLeft, setTooltipLeft] = useState("50%");
  const tooltipRef = useRef(null);

  const handleTooltipToggle = () => {
    setShowTooltip((prevState) => !prevState);
  };

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setShowTooltip(false);
    }
  };

  useEffect(() => {
    if (showTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);

      if (tooltipRef.current) {
        const height = tooltipRef.current.offsetHeight;
        setTooltipHeight(height);

        // Get the container dimensions
        const container = document.querySelector(".app-container");
        const containerRect = container.getBoundingClientRect();

        // Get the tooltip dimensions and position
        const tooltipRect = tooltipRef.current.getBoundingClientRect();

        // Get the position the tooltip and container starts and ends
        const containerStarts = containerRect.left;
        const tooltipStarts = tooltipRect.left;
        const containerEnds = containerRect.width + containerStarts;
        const tooltipEnds = tooltipRect.width + tooltipStarts;

        // Get the amount our tooltip overhangs with a guttering of 24px
        const tooltipUnderhang = tooltipStarts;

        // Set our dimensions and positioning for manipulating;
        let newPositioning = 0.000000000000001;

        if (tooltipEnds > containerEnds && tooltipUnderhang > containerStarts) {
          const overhang = tooltipEnds - containerEnds;

          newPositioning = overhang + 24;
        } else if (
          tooltipStarts < containerStarts &&
          tooltipEnds < containerEnds
        ) {
          const overhang = tooltipStarts - containerStarts;
          newPositioning = overhang - 24;
        }

        if (newPositioning) {
          setTooltipLeft(newPositioning + "px");
        }
      }
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <div className="relative inline-block align-middle pl-1">
      <div>
        <ToolTipIcon className="w-5 h-5 block" onClick={handleTooltipToggle} />
        {showTooltip && (
          <div className="bg-[#E3E3E3] w-[21px] h-[21px] rotate-45 absolute top-[-21px] left-1/2 -translate-x-1/2"></div>
        )}
      </div>

      {showTooltip && (
        <div
          ref={tooltipRef}
          className="w-[257px] absolute bg-[#E3E3E3] text-center -translate-x-1/2"
          style={{
            top: `-${tooltipHeight + 10}px`,
            left: `calc(50% - ${tooltipLeft})`,
            transform: ``,
            padding: "8.5px 12px",
            borderRadius: "4px",
          }}
        >
          <p className="text-base leading-[26px] text-[#101820]">{text}</p>
        </div>
      )}
    </div>
  );
}

ToolTip.propTypes = {
  text: PropTypes.string.isRequired,
};
